export const MASKED_DATE_PLACEHOLDER = "dd/mm/aaaa";

export const MASKED_DATE_INPUT_MASK = [
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
] as const;

export function isoDateToMaskedDisplay(isoDate: string | null | undefined): string {
  if (!isoDate) {
    return "";
  }

  const normalizedDate = isoDate.includes("T") ? isoDate.split("T")[0] : isoDate;
  const [year, month, day] = normalizedDate.split("-");

  if (!year || !month || !day) {
    return "";
  }

  return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
}

export function maskedDisplayToIsoDate(displayDate: string): string | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(displayDate.trim());

  if (!match) {
    return null;
  }

  const [, dayText, monthText, yearText] = match;
  const day = Number(dayText);
  const month = Number(monthText);
  const year = Number(yearText);

  const parsedDate = new Date(year, month - 1, day);

  if (
    parsedDate.getFullYear() !== year ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getDate() !== day
  ) {
    return null;
  }

  return `${yearText}-${monthText}-${dayText}`;
}

export function isCompleteMaskedDate(displayDate: string): boolean {
  return maskedDisplayToIsoDate(displayDate) !== null;
}
